import { render, staticRenderFns } from "./onboarding-list.vue?vue&type=template&id=623dd860&scoped=true&"
import script from "./onboarding-list.vue?vue&type=script&lang=js&"
export * from "./onboarding-list.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-list.vue?vue&type=style&index=0&id=623dd860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623dd860",
  null
  
)

export default component.exports